import type { FC } from 'react';
import React from 'react';

interface EmojiSmallProps {
  className: string;
}

const EmojiSmall: FC<EmojiSmallProps> = ({ className }) => (
  <svg
    viewBox="-2 -2 19 19"
    fill="currentColor"
    width="19"
    height="19"
    className={className}
  >
    <path d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm0-1a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM5 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4.53 4.575c-.639.444-1.03.708-2.03.708-1 0-1.564-.194-2.175-.666-.611-.473-1-.867-1.25-1.617-.056-.167-.083-.536 0-.675a.677.677 0 0 1 .333-.292.603.603 0 0 1 .492.042c.139.083.203.194.258.333.167.5.459.903.875 1.209.417.305.967.458 1.467.458.5 0 .88-.153 1.325-.458A2.12 2.12 0 0 0 9.7 9.408a.677.677 0 0 1 .292-.333.527.527 0 0 1 .458-.042.506.506 0 0 1 .333.292.84.84 0 0 1 .042.458 3.25 3.25 0 0 1-1.295 1.792zM10 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
  </svg>
);

export default EmojiSmall;
